import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const UnidadMedidaApp = Loadable(lazy(() => import('./view/UnidadMedida')))

export const unidadMedidaRouteMap = {
  gestion: {
    path: '/unidad-medida/gestion',
    name: 'Unidades de medida',
    action: 'UNIDADES_DE_MEDIDA',
  },
  registro: {
    path: '/unidad-medida/nuevo',
    name: 'Nueva unidad medida',
    action: 'ADMINISTRAR_UNIDAD_MEDIDA',
  },
  actualizar: {
    path: '/unidad-medida/actualizar/:id',
    name: 'Actualizar unidad medida',
    action: 'ADMINISTRAR_UNIDAD_MEDIDA',
  },
}
const unidadMedidaRoutes = [
  {
    path: unidadMedidaRouteMap.gestion.path,
    element: (
      <OperacionesProvider>
        <UnidadMedidaApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default unidadMedidaRoutes
